// extracted by mini-css-extract-plugin
export default {"video-player":"_2J0FG","videoPlayer":"_2J0FG"};